import { API as e, Resource as t } from "@coveo/platform-client";
// src/resources/DocumentIdentityResource.ts
var n = class n extends t {
	static {
		this.baseUrl = `/rest/organizations/${e.orgPlaceholder}/indexes`;
	}
	getIdentityPermissions(e, t, r) {
		return this.api.post(`${n.baseUrl}/${e}/documents/${encodeURIComponent(encodeURIComponent(t))}/permissions/identity`, r);
	}
};
export { n as DocumentIdentityResource };

//# sourceMappingURL=DocumentIdentityResource.js.map